<template>
  <div id="wrapper">
    <div class="card small-card" id="about">
      <h2>Kaado unifies your productivity needs.</h2>

      <p>
        Ever found a new fitness app and after two weeks realized that you
        abandoned your habit tracker? An inherent problem of user-space
        productivity tools is the laser focus on specific problems (say, calorie
        tracking). Why is that a problem? Single-purpose tools work well within
        themselves, but few people manage to use several of them alongside each
        other, consistently. That is a completely avoidable problem! Kaado
        unifies all your personal productivity needs. It does so with a simple
        assumption: Everything is a flashcard. The following card types exist:
      </p>

      <h3>Learning</h3>
      Classic front/back prompts to memorize things. Think "What is the capital
      of Argentina?" on the front and "Buenos Aires" on the back. Works with a
      spaced repetition algorithm so time between prompts is optimized.
      <h3>Habits</h3>
      Recurring actions you want to do - you can set the frequency individually.
      For example "Stand up and walk around your room" every two hours.
      <h3>Checks</h3>
      Checks: Recurring prompts, similar to habits, but always questions
      referring to the past - for example a daily "Did you drink enough today?"
      prompt.
      <h3>To-Do</h3>
      One time actions that are deleted upon completion.
      <h3>Reading List</h3>
      Reading List: Used for books, articles, talks etc. There are always a
      limited number of reading list items active, which will prompt you to read
      a page a day until you are done with the given book.

      <h3>Other</h3>
      Other: Everything else - interesting websites, quotes, art or even memes
      that you will occasionally see.

      <p>
        The key is that you have a single card shown at a given time - no more
        dreadfully long to-do lists, and no more choice fatigue what to do
        first. Enjoy!
      </p>

         <router-link
          to="/register"
          class="button button-primary"
          id="landing-button"
        >
          Create an Account</router-link
        >
    </div>
  </div>
</template>
